import { render, staticRenderFns } from "./AddQuestion.vue?vue&type=template&id=6ad1dc92&lang=pug&"
import script from "./AddQuestion.vue?vue&type=script&lang=js&"
export * from "./AddQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports